// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ArticleLocationVO')
export class ArticleLocationVO {
  @JsonProperty('checkConnectionProperties', 'Boolean')
  public checkConnectionProperties: boolean = true;

  @JsonProperty('existingArticleUsageId', 'String')
  public existingArticleUsageId: string = null;

  @JsonProperty('articleOffset', 'Number')
  public articleOffset: number;
  public data: any[] = [];
}
